import { FC } from 'react';

import { formatPrice } from '@shared/utils/formatPrice';

import { SurchargeSuggestion } from '../utils/giftFreeShippingNudge.util';

interface IProps {
  suggestion: SurchargeSuggestion;
  onAdd?: (suggestion: SurchargeSuggestion) => void;
  /** 여러 상품이 있는 화면(장바구니 결제)에서만 상품명을 붙인다 */
  showItemName?: boolean;
  disabled?: boolean;
}

/**
 * "N개 더 담으면 소량주문 추가금이 빠져요" 한 줄 + 담기 버튼 — 상세 하단 바·결제 버튼 위 공용.
 * 더 담는 쪽이 오히려 싼 경우(추가 상품값 < 사라지는 추가금)는 그 사실을 앞세운다.
 */
export const GiftSurchargeNudgeLine: FC<IProps> = ({
  suggestion,
  onAdd,
  showItemName = false,
  disabled = false,
}) => {
  const { addQty, surchargeTotal, netAddCost, itemName } = suggestion;
  const cheaper = netAddCost <= 0;

  return (
    <div className="flex items-center justify-between gap-2 text-xs">
      <p className="min-w-0 break-keep text-gray-700">
        {showItemName && <span className="font-bold">{itemName} </span>}
        <span className="font-bold text-amber-700">{addQty}개</span>
        {cheaper ? (
          <>
            {' '}
            더 담는 게{' '}
            <span className="font-bold text-amber-700">
              {netAddCost < 0 ? `${formatPrice(-netAddCost)}원 더 저렴` : '같은 금액'}
            </span>
            <span className="text-gray-400">
              {' '}
              (소량주문 추가금 {formatPrice(surchargeTotal)}원 빠짐)
            </span>
          </>
        ) : (
          <>
            만 더 담으면 소량주문 추가금 {formatPrice(surchargeTotal)}원이 빠져요
            <span className="text-gray-400"> (결제액 +{formatPrice(netAddCost)}원)</span>
          </>
        )}
      </p>
      {onAdd && (
        <button
          type="button"
          disabled={disabled}
          onClick={() => onAdd(suggestion)}
          className="flex-shrink-0 whitespace-nowrap rounded-full border border-amber-400 bg-amber-50 px-3 py-1 font-bold text-amber-700 disabled:opacity-50"
        >
          {addQty}개 더 담기
        </button>
      )}
    </div>
  );
};
